import type { BlogPost, BlogPostMetadata } from './types';
import baubitModularEcosystem from './posts/baubit-modular-ecosystem';
import welcome from './posts/welcome';

const posts: BlogPost[] = [baubitModularEcosystem, welcome];

let cachedPostsMetadata: BlogPostMetadata[] | null = null;

export function getAllPosts(): BlogPostMetadata[] {
    if (cachedPostsMetadata) {
        return cachedPostsMetadata;
    }

    cachedPostsMetadata = posts
        .map(
            (post): BlogPostMetadata => ({
                slug: post.slug,
                title: post.title,
                date: post.date,
                description: post.description,
                tags: post.tags,
            })
        )
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    return cachedPostsMetadata;
}

export function getPostBySlug(slug: string): BlogPost | undefined {
    return posts.find((post) => post.slug === slug);
}

export function getPostsByTag(tag: string): BlogPostMetadata[] {
    return getAllPosts().filter((post) => post.tags?.includes(tag));
}

export function getAllTags(): string[] {
    const tagsSet = new Set<string>();
    posts.forEach((post) => {
        post.tags?.forEach((tag) => tagsSet.add(tag));
    });
    return Array.from(tagsSet).sort();
}
